import { render } from "./details.vue?vue&type=template&id=b7983880&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=b7983880&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7983880"],['__file',"src/views/Membership/component/Places/details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7983880"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7983880', __exports__)) {
    api.reload('b7983880', __exports__)
  }
  
  module.hot.accept("./details.vue?vue&type=template&id=b7983880&scoped=true", () => {
    api.rerender('b7983880', render)
  })

}


export default __exports__